import { post } from 'src/helpers/api/common';

let taskCount = 0;

export async function containsCharityName(
  value: string
): Promise<boolean | null> {
  taskCount++;
  const currentTaskCount = taskCount;

  const result = await post(`/contentchecks/charitynames`, value);

  if (currentTaskCount === taskCount) {
    return result.body;
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/api/create.ts